import { Table, TableBody, TableCell, TableRow } from "@/components/ui/table";
import { rollUpLineItems } from "@/lib/rollUpLineItems";

// Read-only summary table of approved Change Order line items
// displayed under the main WO line items. Rendered once per
// approved CO with an amber styling cue and the CO subtotal in
// the header. The material/labor breakout columns are only
// rendered when `form.show_breakdown` is on (preserves Item E
// expand/collapse toggle behaviour). Extracted from
// WorkOrderTab.jsx (Feb 2026, iter181).
export function WOApprovedCOLineItems({ form, fmt }) {
  const approvedCOs = (form.change_orders || []).filter((co) => co.status === "approved");
  if (approvedCOs.length === 0) return null;

  return (
    <div className="space-y-3 mt-3">
      {approvedCOs.map((co) => (
        <div key={co.id} className="border border-amber-200 rounded-lg overflow-hidden bg-amber-50/20">
          <div className="bg-amber-100/50 px-3 py-1.5 flex items-center justify-between">
            <span className="text-xs font-semibold text-amber-800">
              {co.co_number} — {co.description || "Change Order"}
            </span>
            <span className="text-xs font-semibold text-amber-800 tabular-nums">{fmt(co.subtotal || 0)}</span>
          </div>
          <Table>
            <TableBody>
              {rollUpLineItems(co.line_items || [], !!form.show_breakdown, true).map((item, idx) => (
                <TableRow key={item.id || idx} className="bg-amber-50/30">
                  <TableCell className="p-1">
                    <span className="text-xs font-mono text-slate-600">{item.part_number || "—"}</span>
                  </TableCell>
                  <TableCell className="p-1">
                    <span className="text-xs">{item.name || item.description}</span>
                  </TableCell>
                  <TableCell className="text-xs text-right p-1">{item.quantity}</TableCell>
                  {form.show_breakdown && (
                    <TableCell
                      className="text-xs text-right tabular-nums p-1"
                      data-testid={`co-line-material-${co.id}-${idx}`}
                    >
                      {fmt(item.material_total || 0)}
                    </TableCell>
                  )}
                  {form.show_breakdown && (
                    <TableCell
                      className="text-xs text-right tabular-nums p-1"
                      data-testid={`co-line-freight-${co.id}-${idx}`}
                    >
                      {fmt(item.freight_total || 0)}
                    </TableCell>
                  )}
                  {form.show_breakdown && (
                    <TableCell
                      className="text-xs text-right tabular-nums p-1"
                      data-testid={`co-line-labor-${co.id}-${idx}`}
                    >
                      {fmt(item.labor_total || 0)}
                    </TableCell>
                  )}
                  <TableCell className="text-xs text-right font-medium p-1">{fmt(item.total)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      ))}
    </div>
  );
}
